<template>
  <div
    id="question-move"
    class="d-flex justify-content-center flex-column border-radius-2 bg-white m-1 border p-4 shadow"
  >
    <div
      :class="'d-flex flex-row align-items-center justify-content-center w-100'"
    >
      <h5 class="text-center mx-3 font-weight-bold">
        {{ data_object.content }}
      </h5>
    </div>
    <div
      :id="'toggle-' + data_object.id"
      v-if="readingExperience.itemType === 'CLOSED_4OPTIONS'"
    >
      <ul
        class="donate-now mx-4 d-flex flex-column justify-content-center border-radius-2 p-2"
      >
        <li
          class="w-100"
          v-for="(answer, index) of data_object.answers"
          :key="index"
        >
          <input
            type="radio"
            :id="'radio-' + data_object.id + '-' + answer.itemNumber"
            :name="'item-' + data_object.id"
            :value="answer.id"
            disabled
          />
          <label
            :for="'radio-' + data_object.id + '-' + answer.itemNumber"
            :class="
              'm-2 border-radius-1 text-center font-1-em transition-all label-' +
                data_object.id +
                (answer.itemNumber === 4 ? ' correct' : ' not')
            "
            >{{ answer.content }}</label
          >
        </li>
      </ul>
    </div>
    <div
      :id="'toggle-' + data_object.id"
      v-if="readingExperience.itemType === 'CLOSED_TRUE_FALSE'"
    >
      <ul
        class="donate-now mx-4 d-flex flex-column justify-content-center border-radius-2 p-2"
      >
        <li class="w-100">
          <input
            type="radio"
            :id="'radio-' + data_object.id + '-true'"
            :name="'item-' + data_object.id"
            :value="'1'"
            disabled
          />
          <label
            :for="'radio-' + data_object.id + '-true'"
            :class="
              'm-2 border-radius-1 text-center font-1-em transition-all label-' +
                data_object.id +
                (data_object.answerTrueOrFalse === true ? ' correct' : ' not')
            "
            >Verdadero</label
          >
        </li>
        <li class="w-100">
          <input
            type="radio"
            :id="'radio-' + data_object.id + '-false'"
            :name="'item-' + data_object.id"
            :value="'0'"
            disabled
          />
          <label
            :for="'radio-' + data_object.id + '-false'"
            :class="
              'm-2 border-radius-1 text-center font-1-em transition-all label-' +
                data_object.id +
                (data_object.answerTrueOrFalse === false ? ' correct' : ' not')
            "
            >Falso</label
          >
        </li>
      </ul>
    </div>
    <div class="d-flex justify-content-center mt-2">
      <button
        class="btn br-button-primary font-1-em px-4 border-radius-5 mx-2"
        @click="next"
      >
        Siguiente Pregunta
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "br-book-question",
  computed: {
    ...mapState(["readingExperience"]),
  },
  props: {
    data_object: {},
  },
  data() {
    return {
      asked: false,
      correct: false,
    };
  },
  methods: {
    ...mapActions(["nextQuestion"]),
    next() {
      this.nextQuestion();
    },
  },
};
</script>

<style lang="css">
.donate-now {
  list-style-type: none;
  margin: 0 0 0 0 !important;
  padding: 0;
}

.donate-now li {
  float: left;
  margin: 0 0 0 0;
  width: 100% !important;
  position: relative;
}

.donate-now label,
.donate-now input {
  display: block;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.donate-now input[type="radio"] {
  opacity: 0.011;
  z-index: 100;
  display: none;
}

.donate-now input[type="radio"]:checked + label {
  background: #4e4c56;
  color: white;
}

.incorrect {
  background: #b81212 !important;
  color: white;
}

.correct {
  background: #147a06 !important;
  color: white;
}

.donate-now label {
  padding: 1vh;
  border: 1px solid #ccc;
  cursor: pointer;
  z-index: 90;
}

.donate-now label:hover {
  background: #ddd;
}
</style>
